import { useState } from "react";
import { Get, Set } from "../../../../../../Request";

import { useParams } from "react-router";

export const useShiftDate = () => {
  const { slug } = useParams();
  const [list, setList] = useState();
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState({ list: true });
  const [date, setDate] = useState(false);
  const [form, setForm] = useState({});
  const [loadingBtn, setloadingBtn] = useState(false);
  const getShifts = async () => {
    setLoading({ list: true });
    await Get({
      url: "/timetable/getshift",
      data: { item_id: slug },
    }).then(response => {
      setList({ data: response, shifts: sortShifts(response) });
      setLoading({ list: false });
    });
  };
  const sortShifts = data => {
    let shifts = [];
    data &&
      data.times &&
      data.times.map(date => {
        date.shifts &&
          date.shifts.map(shift => {
            shifts.push({ ...shift, date: date.date, day: date.id });
          });
      });
    return shifts;
  };
  const updateTimeTable = async data => {
    setloadingBtn(true);
    await Set({
      url: "/item/update_timetable",
      data: { ...data, item_id: slug },
    }).then(() => {
      setModal(false);
      setloadingBtn(false);
      getShifts();
    });
  };
  const checkDate = (data, list) => {
    let isDate = false;
    list.data.times.map(time => {
      if (time.date == data.date) {
        isDate = time.id;
      }
    });
    if (isDate) {
      updateTimeTable({
        id: "new",
        day: isDate,
        ...data,
      });
    } else {
      updateTimeTable({
        day: "new",
        date: data.date,
        table: [
          {
            ...data,
          },
        ],
      });
    }
  };
  return {
    list,
    loading,
    getShifts,
    setModal,
    modal,
    updateTimeTable,
    form,
    setForm,
    date,
    setDate,
    checkDate,
    loadingBtn,
  };
};
